import React, { useEffect, useMemo, useState, useCallback } from 'react'
import {Dropdown } from 'react-bootstrap'
import {GENERIC_VALIDATION, LIST, VALIDATION_BY_PARAMETER_LIST, getApiPath} from '../../api/ApiConst';
import ParameterValidationAddEdit from './ParameterValidationAddEdit';
import { useLocation, useNavigate } from 'react-router-dom';
import { isActiveRecord, isDeleteRecord, isInActiveRecord } from '../common/utilities/ConfirmationAlert';
import * as NavConst from '../constants/NavigationConstants';
import TableFilter from '../constants/TableFilter';

const SingleParameterValidation = ({data}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [drawCount, setDrawCount] = useState(0);
    const parameterDetail = location.state;
    const [showValidationModel, setShowValidationModel] = useState(false);
    const [validationObj, setValidationObj] = useState({
        id: "",
        name: "",
        description: "",
        message: "",
        type: "",
        requestParameterId: "",
        constraintValues: {},
    });
    const [parameterId, setParameterId] = useState(0);
    const [parameterType, setParameterType] = useState("");
    const [parameterName, setParameterName] = useState("");
    const [selectedRequestObj, setSelectedRequestObj] = useState({
        _id: "",
        name: ""
    });

    const toggleValidationModel = () => {
        setShowValidationModel(prev => !prev)
    }
    

    const handleCreateParameterValidation = () => {
        let rObj = {
            name: "",
            description: "",
            message: "",
            type: "",
            requestParameterId: parameterId,
            constraintValues: {},
        };
        setValidationObj(rObj);
        toggleValidationModel();
    }

    // Edit Validation Data 
    const handleEditParameterValidation = data => {
        let rObj = {
            id: data._id,
            name: data.name,
            description: data.description,
            message: data.message,
            type: data.type,
            requestParameterId: data.requestParameterId,
            constraintValues: data.constraintValues ? data.constraintValues : {},
        };
        setValidationObj(rObj);
        toggleValidationModel();
    }

    useEffect(() => {
        if (data) {
            setParameterId(data.id);
            setParameterName(data.name);
            setParameterType(data?.type)
        }
    }, [])

    // Parameter Validation Table Action Buttons
    const getParameterValidationActionButtons = (row) => {
        return (
            <Dropdown className='custom-dropdown'>
                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                    <i className="fa fa-chevron-down"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item
                        href={undefined}
                        onClick={() =>
                            handleEditParameterValidation(row)
                        }
                    >
                        <i className="fa fa-edit me-2"></i> Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                        href={undefined}
                        onClick={(row) =>
                            isDeleteRecord(row)
                            // handleTableDataDelete(row)
                        }
                    ><i className="fa fa-trash me-2"></i> Delete</Dropdown.Item>
                    <Dropdown.Item
                        href={undefined}
                        onClick={(row) =>
                            isActiveRecord(row)
                        }
                    ><i className="fa fa-circle-check me-2"></i> Active</Dropdown.Item>
                    <Dropdown.Item
                        href={undefined}
                        onClick={(row) =>
                            isInActiveRecord(row)
                        }
                    ><i className="fa fa-circle-xmark me-2" ></i> InActive</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        )
    }


    const viewParameterValidationList = useCallback(
        () => {
            return (
                <><div className="row justify-content-end p-0">
                    <div className="col-12">
                        <div className='card' style={{margin:"0"}}>
                            <div className="card-body p-0 rqd_card_body">
                                {/* <div className='d-flex gap-3 justify-content-center' style={{margin:"20px 0 0"}}>
                                    <h5>Parameter <b>"{parameterName}"</b> Validation List</h5>
                                </div> */}
                                    <a href={undefined} style={{fontSize:"12px",margin:" 10px 10px"}} className="btn btn-primary" onClick={handleCreateParameterValidation}>
                                        Create New Validation
                                    </a>
                                <TableFilter
                                    tableName="parameter_validation"
                                    tableUrl={getApiPath(GENERIC_VALIDATION, LIST)}
                                    // tableUrl={validationListUrl}
                                    paginationStatus={true}
                                    drawCount={drawCount}
                                    showRecordUpdateModel={handleEditParameterValidation}
                                    specificFilters={[{
                                        columnName: "requestParameterId",
                                        columnValue: data?.id,
                                        operation: "EQUAL_TO",
                                    }]}
                                    refreshTableData={() => setDrawCount((pre) => (pre + 1))}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                </>
            )
        },
        [parameterName, drawCount],
    );

    return (
        <>
            {viewParameterValidationList()}
            {parameterType &&
                <ParameterValidationAddEdit
                    show={showValidationModel}
                    close={toggleValidationModel}
                    parameterType={parameterType}
                    successCallBack={() => setDrawCount((pre) => (pre + 1))}
                    object={validationObj}
                />
            }
        </>
    )
}

export default SingleParameterValidation